const AppointmentComponent = () => import('./appointment-component.vue')
const RequestAppointmentComponent = () => import('./request-appointment-component.vue')

export {
    AppointmentComponent,
    RequestAppointmentComponent,
}